import { GDMConditionalRenderPropsComponent } from './GDMConditionalRender.type';

const GDMConditionalRender: GDMConditionalRenderPropsComponent = ({ canRender, children }) => {
  return canRender ? children : <></>;
};

export default GDMConditionalRender;
